import { GPayIcon, MastercardIcon, WayniIcon } from 'assets/icons'

interface PaymentMethodsIconsProps {
  paymentMethods: {
    wayni: string
    mastercard: string
    gpay: string
  }
  isDetail?: boolean
}

const PaymentMethodsIcons = ({
  paymentMethods,
  isDetail = false
}: PaymentMethodsIconsProps) => {
  const iconsToRender = [
    {
      key: 'wayni',
      component: (
        <WayniIcon className='h-4 pt-[1px] w-[1.125rem] !fill-green-800' />
      ),
      isVisible: isDetail ? false : paymentMethods.wayni
    },
    {
      key: 'mastercard',
      component: <MastercardIcon className='h-[18px]' />,
      isVisible: paymentMethods.mastercard
    },
    {
      key: 'gpay',
      component: <GPayIcon className='h-[18px]' />,
      isVisible: paymentMethods.gpay
    }
  ].filter((method) => method.isVisible === 'true')

  return (
    <>
      {iconsToRender.map((method, index) => (
        <div key={method.key} className='flex items-center'>
          {index > 0 && !isDetail && (
            <span className='font-manropeMedium text-black text-xs mx-1'>
              +
            </span>
          )}
          {method.component}
        </div>
      ))}
    </>
  )
}

export default PaymentMethodsIcons
